/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { RouteItem, UserPermissions } from "./types";
import Login from "./views/Login";
import BulkQnaPage from "./views/BulkQnaPage";
import ScreeningPage from "./views/ScreeningPage";
import ImageIntel from "./views/ImageIntel";
import QuestionPage from "./views/QuestionPage";
import HistoricalExecutions from "./views/HistoricalExecutions";
import BulkQnaExecs from "./views/BulkQnaExecs";
import Users from "./views/Users";
import Reports from "./views/Reports";
import ExecutionInfo from "./views/ExecutionInfo";
import DataAnalysis from "./views/DataAnalysis";
import Chat from "./views/Chat";
import BulkExtractPage from "./views/BulkExtractPage";
import TranslatePage from "./views/TranslatePage";
import ImageIntellExecutionPage from "./views/ImageIntellExecutionPage";
import DocStructuringPage from "./views/DocStructuringPage";
import DocStructuringExecs from "./views/DocStructuringExecs";

const routes: RouteItem[] = [
  {
    path: "/qna",
    name: "Infinity Search",
    icon: "fas fa-question text-primary",
    component: QuestionPage,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.write],
  },
  {
    path: "/data-analysis",
    name: "Data Cockpit",
    icon: "fas fa-chart-pie",
    component: DataAnalysis,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.dataanalysis],
  },
  {
    path: "/image-intel/:id",
    name: "Image Intell Execution",
    icon: "",
    component: ImageIntellExecutionPage,
    layout: "/admin",
    isSidebarItem: false,
    allow: [UserPermissions.betauser],
  },
  {
    path: "/image-intel",
    name: "Image Intel (beta)",
    icon: "fas fa-industry text-primary",
    component: ImageIntel,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.betauser],
  },
  {
    path: "/screening",
    name: "InfiLens",
    icon: "fas fa-industry text-primary",
    component: ScreeningPage,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.betauser],
  },
  {
    path: "/bulk-extractor",
    name: "Bulk Extractor",
    icon: "fas fa-industry text-primary",
    component: BulkExtractPage,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.bulkqna],
  },
  {
    path: "/translate",
    name: "Translate",
    icon: "fas fa-font text-primary",
    component: TranslatePage,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.translator],
  },
  {
    path: "/bulk-qna",
    name: "Bulk QnA",
    icon: "fas fa-question text-primary",
    component: BulkQnaPage,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.bulkqna],
  },
  {
    path: "/bulk-qna-executions",
    name: "Bulk QnA Executions",
    icon: "fas fa-history text-primary",
    component: BulkQnaExecs,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.bulkqna],
  },
  {
    path: "/doc-structuring",
    name: "Content Parser",
    icon: "fas fa-file-excel text-primary",
    component: DocStructuringPage,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.bulkqna],
  },
  {
    path: "/doc-structuring-executions",
    name: "Content Parser Execution",
    icon: "fas fa-history text-primary",
    component: DocStructuringExecs,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.bulkqna],
  },
  // {
  //   path: "/upcomingExecutions",
  //   name: "Upcoming Executions",
  //   icon: "fas fa-satellite-dish text-primary",
  //   component: UpcomingExecutions,
  //   layout: "/admin",
  //   isSidebarItem: true,
  //   allow: [UserPermissions.read],
  // },
  {
    path: "/execution/:id",
    name: "Execution",
    icon: "",
    component: ExecutionInfo,
    layout: "/admin",
    isSidebarItem: false,
    allow: [UserPermissions.read],
  },
  // {
  //   path: "/currentExecutions",
  //   name: "Current Executions",
  //   icon: "fas fa-satellite-dish text-primary",
  //   component: CurrentExecutions,
  //   layout: "/admin",
  //   isSidebarItem: true,
  //   allow: [UserPermissions.read],
  // },
  {
    path: "/historicalExecutions",
    name: "Past Executions",
    icon: "fas fa-history text-primary",
    component: HistoricalExecutions,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.read],
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    isSidebarItem: false,
  },
  {
    path: "/reports",
    name: "Reports",
    icon: "fas fa-chart-line text-primary",
    component: Reports,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.admin],
  },
  {
    path: "/users",
    name: "Users",
    icon: "ni ni-circle-08 text-primary",
    component: Users,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.admin],
  },

  {
    path: "/chat/:id",
    name: "Chat",
    icon: "",
    component: Chat,
    layout: "/admin",
    isSidebarItem: false,
    allow: [UserPermissions.dataanalysis],
  },
];
export default routes;
